import React, { Component } from "react";
import Modal from "react-modal";
import PropTypes from "prop-types";
import { DatePicker } from "samba-ui";
import moment from "moment-timezone";

import {
  CloseButtonContainer,
  ConfirmationContainer,
  ConfirmationContent,
  Header,
  Label,
  SubmitButton,
  SubmitButtonContainer,
  SuccessContainer,
  Description,
  SuccessContent,
  GotItButtonContainer
} from "./styles";

import { RECEIVE_CLIENT } from "../../../actions/client";
import { RECEIVE_FEED } from "../../../actions/feed";
import {
  CloseIcon,
  ActiveFeedIcon,
  InactiveFeedIcon
} from "../../../icons/index";

const modalStyles = {
  overlay: {
    display: "flex",
    backgroundColor: "rgba(33,37,48,0.9)"
  },
  content: {
    position: "static",
    margin: "auto",
    zIndex: "1000",
    display: "flex",
    flexDirection: "column",
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    width: "500px",
    padding: 0,
    backgroundColor: "transparent",
    border: "none",
    overflow: "visible"
  }
};

export const RESTART = "restart";
export const PAUSE = "pause";
export const CLIENT = "client";
export const FEED = "feed";

const defaultState = {
  confirmed: false,
  endDate: null
};

class ServiceStopUpdateModal extends Component {
  state = {
    ...defaultState
  };

  handleSubmit = this.handleSubmit.bind(this);
  onChooseDate = this.onChooseDate.bind(this);

  componentDidUpdate(prevProps) {
    if (prevProps.show === true && this.props.show === false) {
      // If the modal is being closed, we should reset the state
      // Can't do this on componentWillUnmount because technically the modal is always mounted
      this.setState({ ...defaultState });
    }
  }

  handleSubmit() {
    const { endDate } = this.state;
    const { onSubmit } = this.props;

    onSubmit(endDate).then(action => {
      // Only change the modal to the success message if it was successful
      const { type } = this.props;
      const actionType = type === CLIENT ? RECEIVE_CLIENT : RECEIVE_FEED;
      if (action.type === actionType) {
        this.setState({ confirmed: true });
      }
    });
  }

  onChooseDate(endDate) {
    if (!moment.isMoment(endDate) || !endDate.isValid()) {
      endDate = null;
    }
    this.setState({ endDate });
  }

  renderBody() {
    const { confirmed, endDate } = this.state;
    const { item, onDismiss, action, type } = this.props;
    const tomorrow = moment().add(1, "days");
    const serviceStart = moment(item.service_start);
    const minDate = tomorrow < serviceStart ? serviceStart : tomorrow;
    // If the action is RESTART and it hasn't been confirmed
    // prompt the user to select a new end date, then set confirmed to true
    if (action === RESTART && !confirmed) {
      return (
        <ConfirmationContainer>
          <ConfirmationContent>
            <Header>
              {type === CLIENT ? "Restart all feeds?" : "Restart feed?"}
            </Header>
            <Label>
              <div>New End Date (optional)</div>
            </Label>
            <DatePicker
              minDate={minDate}
              selectedDate={endDate}
              onChooseDate={this.onChooseDate}
            />
          </ConfirmationContent>
          <SubmitButtonContainer>
            <SubmitButton
              data-cy="confirm-restart-button"
              onClick={this.handleSubmit}
            >
              Confirm Restart
            </SubmitButton>
          </SubmitButtonContainer>
        </ConfirmationContainer>
      );
    }

    // If the action is PAUSE and it hasn't been confirmed
    // prompt the user to confirm the pause, then set confirmed to true
    if (action === PAUSE && !confirmed) {
      return (
        <ConfirmationContainer>
          <ConfirmationContent>
            <Header>
              {type === CLIENT ? "Pause all feeds?" : "Pause feed?"}
            </Header>
            {type === CLIENT && (
              <Description>
                This will pause all feeds for <span>{item.name}</span>,
                effective immediately.
              </Description>
            )}
            {type === FEED && (
              <Description>
                This will pause the feed <span>{item.name}</span>, effective
                immediately.
              </Description>
            )}
          </ConfirmationContent>
          <SubmitButtonContainer>
            <SubmitButton
              data-cy="confirm-pause-button"
              onClick={this.handleSubmit}
            >
              Confirm Pause
            </SubmitButton>
          </SubmitButtonContainer>
        </ConfirmationContainer>
      );
    }

    // Otherwise, show the success message
    return (
      <SuccessContainer>
        <SuccessContent>
          <Description>
            The {type}
            <span> {item.name} </span>
            was successfully {action === RESTART ? "restarted" : "paused"}.
          </Description>
          {action === RESTART ? <ActiveFeedIcon /> : <InactiveFeedIcon />}
        </SuccessContent>
        <GotItButtonContainer>
          <SubmitButton onClick={onDismiss} primary>
            Got it
          </SubmitButton>
        </GotItButtonContainer>
      </SuccessContainer>
    );
  }

  render() {
    const { show, shouldCloseOnOverlayClick, onDismiss } = this.props;

    return (
      <Modal
        isOpen={show}
        onRequestClose={onDismiss}
        style={modalStyles}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      >
        <CloseButtonContainer onClick={onDismiss}>
          <CloseIcon />
        </CloseButtonContainer>
        {show && this.renderBody()}
      </Modal>
    );
  }
}

ServiceStopUpdateModal.defaultProps = {
  shouldCloseOnOverlayClick: true
};

ServiceStopUpdateModal.propTypes = {
  show: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  action: PropTypes.oneOf([RESTART, PAUSE]),
  type: PropTypes.oneOf([CLIENT, FEED]),
  item: PropTypes.shape({
    name: PropTypes.string
  }),
  onSubmit: PropTypes.func,
  onDismiss: PropTypes.func
};

export default ServiceStopUpdateModal;
